// extracted by mini-css-extract-plugin
export default {"table__header":"itemList_table__header__jSAD4","table":"itemList_table__xkUMR","totals":"itemList_totals__Y3LTd","words":"itemList_words__cycEp","sign":"itemList_sign__tBRcS"};